import PolicyEditor from 'components/PolicyEditor/PolicyEditor';
import { useGetUserAgreementQuery, useUpdateUserAgreementMutation } from '../../api/api';

const UserAgreementPage = () => {
  const { data: userAgreement } = useGetUserAgreementQuery();
  const [updateUserAgreement, { isLoading }] = useUpdateUserAgreementMutation();

  const handleUpdate = async (markdown: string) => {
    await updateUserAgreement(markdown).unwrap();
  };

  return (
    <PolicyEditor
      title="User Agreement"
      initialText={userAgreement?.text}
      onUpdate={handleUpdate}
      isLoading={isLoading}
    />
  );
};

export default UserAgreementPage;